import Loadable from 'react-loadable';

import { mergeQueuesRouteResource } from 'src/components/merge-queues';
import { containersImageTagResource } from 'src/components/packages/resources/container/containers-image-tag-resource';
import { containersImageTagsResource } from 'src/components/packages/resources/container/containers-image-tags-resource';
import { packagesMavenBaseVersionResource } from 'src/components/packages/resources/maven/maven-base-version-resource';
import { packagesMavenBaseVersionsResource } from 'src/components/packages/resources/maven/maven-base-versions-resource';
import { packagesMavenVersionResource } from 'src/components/packages/resources/maven/maven-version-resource';
import { packagesMavenVersionsResource } from 'src/components/packages/resources/maven/maven-versions-resource';
import { packagesAvailabilityResource } from 'src/components/packages/resources/packages-availability-resource';
import { packagesResource } from 'src/components/packages/resources/packages-resource';
import {
  packagesNpmVersionResource,
  packagesNugetVersionResource,
} from 'src/components/packages/resources/packages-version-resource';
import {
  packagesNpmVersionsResource,
  packagesNugetVersionsResource,
} from 'src/components/packages/resources/packages-versions-resource';
import DeploymentsLoadable from 'src/components/pipelines/pages/deployments';
import PipelinesLoadable from 'src/components/pipelines/pages/pipelines';
import { TestManagementLoadable } from 'src/components/pipelines/pages/test-management';
import { TestExecutionLoadable } from 'src/components/pipelines/pages/test-management/test-execution';
import { loadAgenticPipelinesConfiguration } from 'src/components/pipelines/resources/agentic-pipelines-configuration';
import { loadAllowanceResource } from 'src/components/pipelines/resources/allowance';
import { loadPipelinesRepositoryAssociationSummaryResource } from 'src/components/pipelines/resources/association-summary';
import { loadCurrentPipelineResource } from 'src/components/pipelines/resources/current-pipeline';
import { loadDeploymentDashboardResource } from 'src/components/pipelines/resources/deployment-dashboard';
import { loadRepositoryDynamicPipelinesResource } from 'src/components/pipelines/resources/dynamic-pipelines';
import { loadPipelinesRepositoryKeyPairResource } from 'src/components/pipelines/resources/key-pair';
import { loadPipelinesRepositoryKnownHostsResource } from 'src/components/pipelines/resources/known-hosts';
import { loadPipelineBranchResource } from 'src/components/pipelines/resources/pipeline-branch';
import { loadPipelineCreatorsResource } from 'src/components/pipelines/resources/pipeline-creators';
import { loadPipelineRunsResource } from 'src/components/pipelines/resources/pipeline-runs';
import { loadPipelinesResource } from 'src/components/pipelines/resources/pipelines';
import {
  loadPipelinesRepositoryRunnersResource,
  loadPipelinesWorkspaceRunnersResource,
} from 'src/components/pipelines/resources/runners';
import { loadRunnersStepQueueStatsResource } from 'src/components/pipelines/resources/runners-step-queue-stats';
import { loadStepsResource } from 'src/components/pipelines/resources/steps';
import {
  loadFixFlakyTestStatusResource,
  loadTestCaseResource,
  loadTestCasesResource,
} from 'src/components/pipelines/resources/test-cases';
import { loadTestExecutionsResource } from 'src/components/pipelines/resources/test-executions';
import { loadTestsSettingsResource } from 'src/components/pipelines/resources/tests-settings';
import { loadWorkspaceAllowanceResource } from 'src/components/pipelines/resources/workspace-allowance';
import { LayoutLoadingPage, LoadingPage } from 'src/components/react-loadable';
import { customMergeChecksConfigRouteResource } from 'src/components/settings/merge-checks/resources';
import { loadGlobalResource } from 'src/redux/global/resources/load-global';
import { loadPullRequestResource } from 'src/redux/pull-request/resources/load-pull-request';
import { loadRepositoryDetailsResource } from 'src/redux/repository/resources/load-repository-details-resource';
import { loadRepositoryResource } from 'src/redux/repository/resources/load-repository-resource';
import { loadRepositoryResourcePipelines } from 'src/redux/repository/resources/load-repository-resource-pipelines';
import CreateBranchPageLoadable from 'src/sections/create-branch/containers/entry';
import { forgeRepositoryNavigationResource } from 'src/sections/repository/forge-repository-navigation-resource';
import { repositoryNavigationResource } from 'src/sections/repository/repository-navigation-resource';
import { RepoSettingsAccessKeysLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/access-keys';
import { AccessTokensLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/access-tokens';
import { BranchRestrictionsLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/branch-restrictions';
import { BranchingModelLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/branching-model';
import { CodeReviewerRepoPageLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/code-reviewer';
import { DefaultReviewersLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/default-reviewers';
import { DefaultTasksLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/default-tasks';
import { ExcludedFilesLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/excluded-files';
import { MergeChecksLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/merge-checks';
import { MergeQueuesSettingsLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/merge-queues';
import { RepoSettingsMergeStrategiesLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/merge-strategies';
import { RepoSettingsPermissionsLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/permissions';
import { loadRepositorySettingsPermissionsResource } from 'src/sections/repository/sections/admin/components/settings-pages/permissions/resources';
import PipelinesRepoDeploymentsPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/deployments';
import PipelinesRepoDynamicPipelinesPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/dynamic-pipelines';
import PipelinesRepoOpenIDPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/openid';
import PipelinesRepoRunnersPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/runners';
import PipelinesRepoSettingsPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/settings';
import PipelinesRepoSshKeysPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/ssh-keys';
import PipelinesRepoVariablesPageLoadable from 'src/sections/repository/sections/admin/components/settings-pages/pipelines/variables';
import { ReviewGroupsLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/review-groups';
import { DetectionSettingsLoadable } from 'src/sections/repository/sections/admin/components/settings-pages/tests/detection-settings';
import { loadConnectWebhooksResource } from 'src/sections/repository/sections/admin/components/settings-pages/webhooks/resources/load-connect-webhooks-resource';
import { loadRepositoryWebhooksResource } from 'src/sections/repository/sections/admin/components/settings-pages/webhooks/resources/load-repository-webhooks-resource';
import { loadWorkspaceWebhooksResource } from 'src/sections/repository/sections/admin/components/settings-pages/webhooks/resources/load-workspace-webhooks-resource';
import SettingsConnectIframe from 'src/sections/repository/sections/admin/containers/settings-connect-iframe';
import SettingsIframe from 'src/sections/repository/sections/admin/containers/settings-iframe';
import JiraMigrationLoadable from 'src/sections/repository/sections/admin/sections/jira-migration';
import BranchesListLoadable from 'src/sections/repository/sections/branches';
import ColdStorageLoadable from 'src/sections/repository/sections/cold-storage';
import { loadCommitResource } from 'src/sections/repository/sections/commit/resources/load-commit-resource';
import CommitListLoadable from 'src/sections/repository/sections/commit-list';
import { loadBranchesResource } from 'src/sections/repository/sections/create-pull-request/resources/load-branches-resource';
import { MergeQueuesLoadable } from 'src/sections/repository/sections/merge-queues';
import { loadForgeMergeChecksResultsResource } from 'src/sections/repository/sections/pull-request/components/merge-checks-card/resources';
import PullRequestListLoadable from 'src/sections/repository/sections/pull-request-list';
import {
  RepoSecurityLandingPageLoadable,
  RepoSecurityLearnMoreLoadable,
} from 'src/sections/repository/sections/security';
import { REPO_FULL_SLUG_REGEX } from 'src/utils/validate-repository-path';

import { Route, ROUTE_NAME, RouteContext, RouteFeatures } from './types';

const RepositoryLayout = Loadable({
  loading: LayoutLoadingPage,
  loader: () => import('src/sections/repository/layout'),
});

const RepositoryRedirect = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () => import('src/sections/repository/repository-redirect'),
});

const SourceCreateFileLoadable = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/source/containers/create-file-route'
    ),
});

const SourceDiffLoadable = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/sections/repository/sections/source/containers/source-diff'),
});

const FileHistoryLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/source/containers/file-history-wrapped'
    ),
});

const RepositoryHistoryRedirect = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/sections/repository/sections/commit-list/history-redirect'),
});

const SourceBrowser = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/source/containers/source-browser-resource-router'
    ),
});

const IframedRepoPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () => import('src/sections/repository/components/iframe-wrapped'),
});

const CommitPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () => import('src/sections/repository/sections/commit/route'),
});

const PackagesPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/sections/repository/sections/packages/packages-page').then(
      m => m.RepositoryPackagesPage
    ),
});

const PackagesContainersImageTagsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/container/packages-containers-image-tags-page'
    ).then(m => m.RepositoryPackagesContainersImageTagsPage),
});
const PackagesContainersImageTagPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/container/packages-containers-image-tag-page'
    ).then(m => m.RepositoryPackagesContainersImageTagPage),
});

const PackagesNpmVersionsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/npm/packages-npm-versions-page'
    ).then(m => m.RepositoryPackagesNpmVersionsPage),
});
const PackagesNpmVersionPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/npm/packages-npm-version-page'
    ).then(m => m.RepositoryPackagesNpmVersionPage),
});
const PackagesMavenBaseVersionsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/maven/packages-maven-base-versions-page'
    ).then(m => m.RepositoryPackagesMavenBaseVersionsPage),
});
const PackagesMavenBaseVersionPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/maven/packages-maven-base-version-page'
    ).then(m => m.RepositoryPackagesMavenBaseVersionPage),
});
const PackagesMavenVersionPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/maven/packages-maven-version-page'
    ).then(m => m.RepositoryPackagesMavenVersionPage),
});
const PackagesNugetVersionsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/nuget/packages-nuget-versions-page'
    ).then(m => m.RepositoryPackagesNugetVersionsPage),
});
const PackagesNugetVersionPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/packages/nuget/packages-nuget-version-page'
    ).then(m => m.RepositoryPackagesNugetVersionPage),
});

const CreatePullRequest = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/sections/repository/sections/create-pull-request/route'),
});

const PullRequest = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/sections/repository/sections/pull-request/containers/page'),
});

const ConnectPageLoadable = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () => import('src/sections/repository/containers/connect-page'),
});

const ForgePageLoadable = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () => import('src/forge/repo-main-menu-page/repo-main-menu-page'),
});

const SettingsForgePageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/forge/repo-settings-menu-page/repo-settings-menu-page'),
});

const JiraViewLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('src/sections/repository/sections/jira'),
});

const loadableWebhooksPage =
  (
    pageName:
      | 'WebhooksLandingPage'
      | 'AddWebhookPage'
      | 'EditWebhookPage'
      | 'ViewWebhookEventPage'
      | 'ViewWebhookDetailsPage'
  ) =>
  () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/webhooks/pages'
    ).then(pages => pages[pageName]);

const WebhooksLandingPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: loadableWebhooksPage('WebhooksLandingPage'),
});

const AddWebhookPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: loadableWebhooksPage('AddWebhookPage'),
});

const EditWebhookPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: loadableWebhooksPage('EditWebhookPage'),
});

const ViewWebhookPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: loadableWebhooksPage('ViewWebhookDetailsPage'),
});

const ViewWebhookEventPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: loadableWebhooksPage('ViewWebhookEventPage'),
});

const RepoDetailsSettingsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/details'
    ),
});

const RepoComplianceSettingsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/compliance'
    ),
});

const RepoUsernameAliasesSettingsPage = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/username-aliases'
    ),
});

const BranchDetailPage = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () => import('src/sections/repository/sections/branch/route'),
});

const PipelinesRepoAdminRedirectDeploymentsSettingsLoadable = Loadable<
  RouteContext,
  never
>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-repo-admin'
    ),
});

const PipelinesRepoAdminRedirectRunnersSettingsLoadable = Loadable<
  RouteContext,
  never
>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-repo-admin'
    ),
});

const PipelinesRepoAdminRedirectSettingsLoadable = Loadable<
  RouteContext,
  never
>({
  loading: LoadingPage,
  loader: () =>
    import(
      'src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-repo-admin'
    ),
});

const PipelinesBuildRedirect = Loadable<RouteContext, never>({
  loading: LoadingPage,
  loader: () =>
    import('src/sections/repository/repository-pipelines-build-redirect'),
});

const RepositorySideNavigationLoadable = Loadable<{}, never>({
  loading: LoadingPage,
  loader: () => import('src/app/nav-system/side-nav/repository-admin'),
});

const legacyPath = (path: string) =>
  `/:repositoryOwner/:repositorySlug/${path}`;
const repoPath = (path: string) => `/${REPO_FULL_SLUG_REGEX}/${path}`;

const defaultResources = [
  loadGlobalResource,
  loadRepositoryResource,
  repositoryNavigationResource,
  forgeRepositoryNavigationResource,
];

export const repositoryRoutes = (features: RouteFeatures): Route[] => {
  const {
    isRepoAdminAliasesEnabled,
    isRepoAdminComplianceEnabled,
    isTestsFixFlakyActionEnabled,
    isNugetPypiUiEnabled,
  } = features;

  // resuable container to improve syntax readability
  let routeGroups: Route[] = [];
  const routes: Route[] = [
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_CREATE_WEBHOOK,
      path: legacyPath('admin/webhooks/new'),
      exact: true,
      component: AddWebhookPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryWebhooksResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_EDIT_WEBHOOK,
      path: legacyPath('admin/webhooks/:webhookUuid/edit'),
      exact: true,
      component: EditWebhookPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryWebhooksResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_VIEW_WEBHOOK_EVENT,
      path: legacyPath('admin/webhooks/:webhookUuid/event/:eventId'),
      exact: true,
      component: ViewWebhookEventPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        // Users can view Repo/Workspace/Connect hook details so we request all 3 types here, but
        // they should already be cached from the visit to the landing page.
        loadRepositoryWebhooksResource,
        loadWorkspaceWebhooksResource,
        loadConnectWebhooksResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_VIEW_WEBHOOK,
      path: legacyPath('admin/webhooks/:webhookUuid'),
      exact: true,
      component: ViewWebhookPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        // Users can view Repo/Workspace/Connect hook details so we request all 3 types here, but
        // they should already be cached from the visit to the landing page.
        loadRepositoryWebhooksResource,
        loadWorkspaceWebhooksResource,
        loadConnectWebhooksResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_WEBHOOKS_ROOT,
      path: legacyPath('admin/webhooks'),
      exact: false,
      component: WebhooksLandingPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryWebhooksResource,
        loadWorkspaceWebhooksResource,
        loadConnectWebhooksResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_CREATE_PR,
      path: legacyPath('pull-requests/new'),
      exact: false,
      component: CreatePullRequest,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadBranchesResource,
        loadRepositoryDetailsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_CODE_REVIEW,
      path: legacyPath(
        'pull-requests/:pullRequestId/:tab(overview|diff|commits)?'
      ),
      exact: false,
      component: PullRequest,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadPullRequestResource,
        loadRepositoryDetailsResource,
        loadForgeMergeChecksResultsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_BRANCH_DETAIL,
      path: legacyPath('branch/:ref+'),
      exact: false,
      component: BranchDetailPage,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_DETAIL,
      path: legacyPath('admin'),
      exact: true,
      component: RepoDetailsSettingsPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PERMISSIONS,
      path: legacyPath('admin/permissions'),
      exact: true,
      component: RepoSettingsPermissionsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositorySettingsPermissionsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_ACCESS_KEYS,
      path: legacyPath('admin/access-keys'),
      exact: true,
      component: RepoSettingsAccessKeysLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    ...[
      legacyPath('annotate/:refOrHash?/:path*'),
      legacyPath('branches/compare/:path*'),
      legacyPath('downloads'),
      legacyPath('issues/:path*'),
      legacyPath('issue-attachment/:path*'),
      legacyPath('issue-duplicate/:path*'),
      legacyPath('wiki/:path*'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_IFRAMED_PAGE,
      path,
      component: IframedRepoPage,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    })),
  ];

  if (isRepoAdminAliasesEnabled) {
    routes.push({
      name: ROUTE_NAME.REPOSITORY_ADMIN_COMMITTERS,
      path: legacyPath('admin/committers'),
      exact: true,
      component: RepoUsernameAliasesSettingsPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    });
  }

  if (isRepoAdminComplianceEnabled) {
    routes.push({
      name: ROUTE_NAME.REPOSITORY_ADMIN_COMPLIANCE,
      path: legacyPath('admin/compliance'),
      exact: true,
      component: RepoComplianceSettingsPage,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    });
  }

  routes.push({
    name: ROUTE_NAME.REPOSITORY_ADMIN_ACCESS_TOKENS,
    path: legacyPath('admin/access-tokens'),
    exact: true,
    component: AccessTokensLoadable,
    sideNavigation: RepositorySideNavigationLoadable,
    layout: RepositoryLayout,
    resources: [...defaultResources],
  });

  routes.push({
    name: ROUTE_NAME.REPOSITORY_ADMIN_FEATURES_CODE_REVIEWER,
    path: legacyPath('admin/code-reviewer'),
    exact: true,
    component: CodeReviewerRepoPageLoadable,
    sideNavigation: RepositorySideNavigationLoadable,
    layout: RepositoryLayout,
    resources: [...defaultResources],
  });

  routes.push(
    ...[
      legacyPath('merge-queues'),
      legacyPath('merge-queues/configs/:mergeQueueUuid'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_MERGE_QUEUES,
      path,
      exact: true,
      component: MergeQueuesLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        mergeQueuesRouteResource,
      ],
    }))
  );

  routeGroups = [
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_REDIRECT_SETTINGS,
      path: legacyPath(
        'admin/addon/admin/:appKey(pipelines)/:moduleKey(settings|openid-connect|ssh-keys|integrations|repository-variables)'
      ),
      exact: true,
      component: PipelinesRepoAdminRedirectSettingsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_REDIRECT_RUNNERS,
      path: legacyPath(
        'admin/addon/admin/:appKey(pipelines)/:moduleKey(runners)'
      ),
      exact: true,
      component: PipelinesRepoAdminRedirectRunnersSettingsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_REDIRECT_DEPLOYMENTS,
      path: legacyPath(
        'admin/addon/admin/:appKey(pipelines)/:moduleKey(deployment-settings)'
      ),
      exact: true,
      component: PipelinesRepoAdminRedirectDeploymentsSettingsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadDeploymentDashboardResource,
        loadRepositoryDetailsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_SETTINGS,
      path: legacyPath('admin/pipelines/:path(settings)'),
      exact: true,
      component: PipelinesRepoSettingsPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadAllowanceResource,
        loadRepositoryDetailsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_OPENID,
      path: legacyPath('admin/pipelines/:path(openid-connect)'),
      exact: true,
      component: PipelinesRepoOpenIDPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadDeploymentDashboardResource,
        loadRepositoryDetailsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_SSH_KEYS,
      path: legacyPath('admin/pipelines/:path(ssh-keys)'),
      exact: true,
      component: PipelinesRepoSshKeysPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadPipelinesRepositoryKeyPairResource,
        loadPipelinesRepositoryKnownHostsResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_RUNNERS,
      path: legacyPath('admin/pipelines/:path(runners)'),
      exact: true,
      component: PipelinesRepoRunnersPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadPipelinesWorkspaceRunnersResource,
        loadPipelinesRepositoryRunnersResource,
        loadRunnersStepQueueStatsResource,
        loadWorkspaceAllowanceResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_DEPLOYMENTS,
      path: legacyPath('admin/pipelines/:path(deployment-settings)'),
      exact: true,
      component: PipelinesRepoDeploymentsPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadPipelinesRepositoryAssociationSummaryResource,
        loadDeploymentDashboardResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_VARIABLES,
      path: legacyPath('admin/pipelines/:path(repository-variables)'),
      exact: true,
      component: PipelinesRepoVariablesPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_PIPELINES_DYNAMIC_PIPELINES,
      path: legacyPath('admin/pipelines/:path(dynamic-pipelines)'),
      exact: true,
      component: PipelinesRepoDynamicPipelinesPageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDynamicPipelinesResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_TESTS_DETECTION_SETTINGS,
      path: legacyPath('admin/tests/detection-settings'),
      exact: true,
      component: DetectionSettingsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadTestsSettingsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_FORGE_PAGE,
      path: legacyPath('admin/forge/:appId/:moduleKey'),
      exact: true,
      component: SettingsForgePageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_FORGE_PAGE,
      path: legacyPath('admin/forge/:appId/:envKey/:moduleKey/:modulePath*'),
      exact: true,
      component: SettingsForgePageLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_BRANCH_RESTRICTIONS,
      path: legacyPath('admin/branch-permissions'),
      exact: true,
      component: BranchRestrictionsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_BRANCH_RESTRICTIONS,
      path: legacyPath('admin/branch-restrictions'),
      exact: true,
      component: BranchRestrictionsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_BRANCHING_MODEL,
      path: legacyPath('admin/branching-model'),
      exact: true,
      component: BranchingModelLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_MERGE_QUEUE,
      path: legacyPath('admin/merge-queues/configs/:mergeQueueUuid'),
      exact: true,
      component: MergeQueuesSettingsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        mergeQueuesRouteResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_MERGE_QUEUES,
      path: legacyPath('admin/merge-queues'),
      exact: true,
      component: MergeQueuesSettingsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        mergeQueuesRouteResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_MERGE_CHECKS,
      path: legacyPath('admin/merge-checks'),
      exact: true,
      component: MergeChecksLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, customMergeChecksConfigRouteResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_MERGE_STRATEGIES,
      path: legacyPath('admin/merge-strategies'),
      exact: true,
      component: RepoSettingsMergeStrategiesLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_DEFAULT_REVIEWERS,
      path: legacyPath('admin/pullrequests/reviewers'),
      exact: true,
      component: DefaultReviewersLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_REVIEW_GROUPS,
      path: legacyPath('admin/pullrequests/review-groups'),
      exact: true,
      component: ReviewGroupsLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_ISSUES_MIGRATION,
      path: legacyPath('admin/issues/jira-migration'),
      exact: true,
      component: JiraMigrationLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_CONNECT_IFRAME,
      path: legacyPath('admin/addon/admin/:appKey/:moduleKey'),
      exact: true,
      // @ts-ignore
      component: SettingsConnectIframe,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_CONNECT_IFRAME,
      path: legacyPath('admin/addon/admin/:appKey/:moduleKey'),
      // @ts-ignore
      component: SettingsConnectIframe,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_EXCLUDED_FILES,
      path: legacyPath('admin/pullrequests/excluded-files'),
      exact: true,
      component: ExcludedFilesLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_DEFAULT_TASKS,
      path: legacyPath('admin/pullrequests/default-pull-request-tasks'),
      exact: true,
      component: DefaultTasksLoadable,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_ADMIN_IFRAME,
      path: legacyPath('admin/:path*'),
      // @ts-ignore
      component: SettingsIframe,
      sideNavigation: RepositorySideNavigationLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
  ];
  routes.push(...routeGroups);

  // repo pages
  routeGroups = [
    {
      name: ROUTE_NAME.REPOSITORY_SOURCE,
      path: legacyPath('src/:refOrHash?/:path*'),
      component: SourceBrowser,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_SOURCE_CREATE_FILE,
      path: legacyPath('create-file/:refOrHash?/:path*'),
      component: SourceCreateFileLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_SOURCE_DIFF,
      path: repoPath('diff/:path+'),
      component: SourceDiffLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_BRANCH_CREATE,
      path: legacyPath('branch'),
      component: CreateBranchPageLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_BRANCHES_LIST,
      path: legacyPath('branches'),
      component: BranchesListLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PULL_REQUESTS,
      path: legacyPath('pull-requests'),
      component: PullRequestListLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_COLD_STORAGE,
      path: legacyPath('cold-storage'),
      component: ColdStorageLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_SECURITY,
      path: legacyPath('security'),
      exact: true,
      component: RepoSecurityLandingPageLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_SECURITY_LEARN_MORE,
      path: legacyPath('security/learn-more'),
      component: RepoSecurityLearnMoreLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },

    ...[
      repoPath('commits'),
      repoPath('commits/all'),
      repoPath('commits/(branch|tag)/:refName(.*)'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_COMMITS,
      path,
      exact: true,
      component: CommitListLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    })),
    {
      name: ROUTE_NAME.REPOSITORY_COMMITS_HISTORY,
      path: repoPath('commits/history'),
      component: RepositoryHistoryRedirect,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
  ];
  routes.push(...routeGroups);

  // packages pages
  routes.push(
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES,
      path: legacyPath('packages'),
      exact: true,
      component: PackagesPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        packagesResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_CONTAINERS_TAGS,
      path: legacyPath('packages/containers/:packageName/tags'),
      exact: true,
      component: PackagesContainersImageTagsPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        containersImageTagsResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_CONTAINERS_TAG,
      path: legacyPath('packages/containers/:packageName/tags/:tagName'),
      exact: true,
      component: PackagesContainersImageTagPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        containersImageTagResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_NPM_VERSIONS,
      path: legacyPath('packages/npm/:packageName/versions'),
      exact: true,
      component: PackagesNpmVersionsPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        packagesNpmVersionsResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_NPM_VERSION,
      path: legacyPath('packages/npm/:packageName/versions/:version'),
      exact: true,
      component: PackagesNpmVersionPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        packagesNpmVersionResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_MAVEN_BASE_VERSIONS,
      path: legacyPath('packages/maven/:packageName/base-versions'),
      exact: true,
      component: PackagesMavenBaseVersionsPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        packagesMavenBaseVersionsResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_MAVEN_BASE_VERSION,
      path: legacyPath(
        'packages/maven/:packageName/base-versions/:mavenBaseVersion'
      ),
      exact: true,
      component: PackagesMavenBaseVersionPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        packagesMavenBaseVersionResource,
        packagesMavenVersionsResource,
        packagesAvailabilityResource,
      ],
    },
    {
      name: ROUTE_NAME.REPOSITORY_PACKAGES_MAVEN_VERSION,
      path: legacyPath(
        'packages/maven/:packageName/base-versions/:mavenBaseVersion/versions/:mavenVersion'
      ),
      exact: true,
      component: PackagesMavenVersionPage,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadRepositoryDetailsResource,
        packagesMavenVersionResource,
        packagesAvailabilityResource,
      ],
    }
  );

  if (isNugetPypiUiEnabled) {
    routes.push(
      {
        name: ROUTE_NAME.REPOSITORY_PACKAGES_NUGET_VERSIONS,
        path: legacyPath('packages/nuget/:packageName/versions'),
        exact: true,
        component: PackagesNugetVersionsPage,
        layout: RepositoryLayout,
        resources: [
          ...defaultResources,
          loadRepositoryDetailsResource,
          packagesNugetVersionsResource,
          packagesAvailabilityResource,
        ],
      },
      {
        name: ROUTE_NAME.REPOSITORY_PACKAGES_NUGET_VERSION,
        path: legacyPath('packages/nuget/:packageName/versions/:version'),
        exact: true,
        component: PackagesNugetVersionPage,
        layout: RepositoryLayout,
        resources: [
          ...defaultResources,
          loadRepositoryDetailsResource,
          packagesNugetVersionResource,
          packagesAvailabilityResource,
        ],
      }
    );
  }

  // commit page
  routes.push({
    name: ROUTE_NAME.REPOSITORY_COMMIT,
    path: legacyPath('commits/:ref+'),
    exact: false,
    component: CommitPage,
    layout: RepositoryLayout,
    resources: [
      ...defaultResources,
      loadCommitResource,
      loadRepositoryDetailsResource,
    ],
  });

  routes.push(
    ...[
      repoPath('deployments/environments/:environmentUuid/:deploymentUuid'),
      repoPath('deployments/environments/:environmentUuid'),
      repoPath('deployments/:deploymentUuid'),
      repoPath('deployments'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_DEPLOYMENTS,
      path,
      component: DeploymentsLoadable,
      layout: RepositoryLayout,
      resources: [
        ...defaultResources,
        loadDeploymentDashboardResource,
        loadRepositoryDetailsResource,
      ],
    }))
  );

  routes.push(
    ...[
      repoPath('pipelines'),
      repoPath('pipelines/filters/:filters'),
      repoPath('pipelines/results'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_PIPELINES,
      exact: true,
      path,
      component: PipelinesLoadable,
      layout: RepositoryLayout,
      resources: [
        loadGlobalResource,
        loadRepositoryResourcePipelines,
        loadPipelinesResource,
        loadPipelineBranchResource,
        loadPipelineCreatorsResource,
        repositoryNavigationResource,
        forgeRepositoryNavigationResource,
        loadDeploymentDashboardResource,
        loadAllowanceResource,
        loadRepositoryDetailsResource,
      ],
    }))
  );

  routes.push(
    ...[
      repoPath('pipelines/results/:pipelineUuid'),
      repoPath('pipelines/results/:pipelineUuid/steps/:stepUuid'),
      repoPath('pipelines/results/:pipelineUuid/from-email'),
      repoPath('pipelines/results/:pipelineUuid/runs/:pipelineRunUuid'),
      repoPath(
        'pipelines/results/:pipelineUuid/runs/:pipelineRunUuid/steps/:stepUuid'
      ),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_PIPELINES_RESULT,
      exact: true,
      path,
      component: PipelinesLoadable,
      layout: RepositoryLayout,
      resources: [
        loadGlobalResource,
        loadRepositoryResourcePipelines,
        loadCurrentPipelineResource,
        loadStepsResource,
        loadPipelineRunsResource,
        repositoryNavigationResource,
        forgeRepositoryNavigationResource,
        loadAllowanceResource,
        loadRepositoryDetailsResource,
        loadAgenticPipelinesConfiguration,
      ],
    }))
  );

  routes.push(
    ...[
      repoPath('pipelines/results/filters/:filters'),
      repoPath('pipelines/results/branch/:branch/page/:page/filters/:filters'),
      repoPath('pipelines/results/page/:page/filters/:filters'),
      repoPath('pipelines/results/branch/:branch/page/:page'),
      repoPath('pipelines/results/page/:page/'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_PIPELINES,
      path,
      component: PipelinesLoadable,
      layout: RepositoryLayout,
      resources: [
        loadGlobalResource,
        loadRepositoryResourcePipelines,
        loadPipelinesResource,
        loadPipelineBranchResource,
        loadPipelineCreatorsResource,
        repositoryNavigationResource,
        forgeRepositoryNavigationResource,
        loadDeploymentDashboardResource,
        loadAllowanceResource,
        loadRepositoryDetailsResource,
      ],
    }))
  );

  routes.push(
    ...[
      repoPath(
        'pipelines/results/:pipelineUuid/steps/:stepUuid/trigger/:trigger'
      ),
      repoPath(
        'pipelines/results/:pipelineUuid/steps/:stepUuid/services/:serviceUuid'
      ),
      repoPath(
        'pipelines/results/:pipelineUuid/runs/:pipelineRunUuid/steps/:stepUuid/services/:serviceUuid'
      ),
      repoPath('pipelines/results/:pipelineUuid/steps/:stepUuid/(.*)'),
      repoPath(
        'pipelines/results/:pipelineUuid/steps/:stepUuid/runs/:pipelineRunUuid/(.*)'
      ),
      repoPath(
        'pipelines/results/:pipelineUuid/runs/:pipelineRunUuid/steps/:stepUuid/(.*)'
      ),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_PIPELINES_RESULT,
      path,
      component: PipelinesLoadable,
      layout: RepositoryLayout,
      resources: [
        loadGlobalResource,
        loadRepositoryResourcePipelines,
        loadCurrentPipelineResource,
        loadStepsResource,
        loadPipelineRunsResource,
        repositoryNavigationResource,
        forgeRepositoryNavigationResource,
        loadAllowanceResource,
        loadRepositoryDetailsResource,
        loadAgenticPipelinesConfiguration,
      ],
    }))
  );

  routes.push({
    name: ROUTE_NAME.REPOSITORY_TEST_MANAGEMENT,
    path: repoPath('tests'),
    exact: true,
    component: TestManagementLoadable,
    layout: RepositoryLayout,
    resources: [
      ...defaultResources,
      loadRepositoryDetailsResource,
      loadTestCasesResource,
      ...(isTestsFixFlakyActionEnabled
        ? [loadAgenticPipelinesConfiguration]
        : []),
    ],
  });

  routes.push({
    name: ROUTE_NAME.REPOSITORY_TEST_EXECUTION,
    exact: true,
    path: repoPath('tests/:testUuid/executions'),
    component: TestExecutionLoadable,
    layout: RepositoryLayout,
    resources: [
      ...defaultResources,
      loadRepositoryDetailsResource,
      loadTestCaseResource,
      loadTestExecutionsResource,
      ...(isTestsFixFlakyActionEnabled
        ? [loadAgenticPipelinesConfiguration, loadFixFlakyTestStatusResource]
        : []),
    ],
  });

  routeGroups = [
    {
      name: ROUTE_NAME.REPOSITORY_PIPELINES_BUILD_REDIRECT,
      path: legacyPath('addon/pipelines/home'),
      exact: true,
      component: PipelinesBuildRedirect,
      layout: RepositoryLayout,
      resources: [loadGlobalResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_FORGE_PAGE,
      path: legacyPath('forge/:appId/:moduleKey'),
      exact: true,
      component: ForgePageLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_FORGE_PAGE,
      path: legacyPath('forge/:appId/:envKey/:moduleKey/:modulePath*'),
      exact: true,
      component: ForgePageLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    ...[
      legacyPath('history/:path+'),
      legacyPath('history-node/:refOrHash/:path+'),
    ].map(path => ({
      name: ROUTE_NAME.REPOSITORY_FILE_HISTORY,
      path,
      component: FileHistoryLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    })),
    {
      name: ROUTE_NAME.REPOSITORY_CONNECT_PAGE,
      path: legacyPath('addon/:appKey/:moduleKey'),
      component: ConnectPageLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources],
    },
    {
      name: ROUTE_NAME.REPOSITORY_JIRA_VIEW,
      path: legacyPath('jira'),
      component: JiraViewLoadable,
      layout: RepositoryLayout,
      resources: [...defaultResources, loadRepositoryDetailsResource],
    },
    {
      name: ROUTE_NAME.REPOSITORY_REDIRECT,
      path: `/${REPO_FULL_SLUG_REGEX}`,
      component: RepositoryRedirect,
      layout: RepositoryLayout,
      resources: [loadGlobalResource],
    },
  ];
  routes.push(...routeGroups);

  return routes;
};
